import { useMutation } from 'react-query';

import { extractDelayDriverCsv as mutationFn } from 'api/endPoints/extractDelayDriverCsv';
import { ISingleSmallCardResponse } from 'api/queries/getListFilteredCards.query';

import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

export const useMutationExtractDelayDriverCsv = () => {
    return useMutation<unknown, QueryError, IExtractDelayDriverCsvPayload>((params) => mutationFn(params));
};

interface IExtractDelayDriverCsvPayload {
    fileMetaDataId: number;
    fileName: string;
    filter: IFilter[] | undefined;
}

export interface ITopOverdueData {
    criticalityScore: number;
    float: null | number;
    taskVersionHashCode: string;
    plannedStartDate: number;
    plannedFinishDate: number;
    actualStartDate: number;
    actualFinishDate: number;
    numOfPredecessors: number;
    numOfSuccessors: number;
    projectWeekStart: number;
    projectWeekFinish: number;
    projectMonthStart: number;
    projectMonthFinish: number;
    activityId: string;
    parentName: string;
    grandParentName: string;
    plannedDuration: number;
    actualDuration: number;
    remainingDuration: number;
    completedDuration: number;
    activityType: string;
    activityName: string;
    overrunDays: number;
    overrunPercent: number;
    criticalPath: boolean;
    delayDriver: boolean;
    currentStartDate: number;
    currentFinishDate: number;
    baselineStartDate: number;
    baselineFinishDate: number;
    durationOverun: number;
    cardBoardViewResponse: ISingleSmallCardResponse;
}
